import { render, staticRenderFns } from "./articleCom.vue?vue&type=template&id=12f9bf50&scoped=true"
import script from "./articleCom.vue?vue&type=script&lang=js"
export * from "./articleCom.vue?vue&type=script&lang=js"
import style0 from "./articleCom.vue?vue&type=style&index=0&id=12f9bf50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9bf50",
  null
  
)

export default component.exports